const baseInputStyles = (theme) => ({
  backgroundColor: 'transparent',
  fontFamily: 'var(--root-font) !important',
  border: 'none',
  '&:focus': {
    outline: 'none'
  },
  '&::placeholder': {
    opacity: '0.2',
    fontWeight: 'bold'
  }
})

const sizes = {
  xs: (theme) => ({
    ...baseInputStyles(theme),
    padding: '2px 10px 2px 10px !important',
    minHeight: '24px',
    lineHeight: '24px',
    fontSize: theme.typography.fontSizes.md
  }),
  sm: (theme) => ({
    padding: '2px 10px 2px 10px !important',
    minHeight: '32px',
    ...baseInputStyles(theme),
    lineHeight: '32px',
    fontSize: theme.typography.fontSizes.xl
  }),
  lg: (theme) => ({
    padding: '9px 10px 9px 15px !important',
    minHeight: '32px',
    lineHeight: '32px',
    ...baseInputStyles(theme),
    fontSize: theme.typography.fontSizes.xl
  })
}

export const mapInputStyles = (theme, rest) => ({ disabled, size }) => ({
  ...rest,
  ...sizes[size](theme),
  backgroundColor: disabled ? 'var(--color-neutral-300)' : 'var(--color-surface-050)'
})
